import { useSearchParams } from 'react-router-dom';
import { useAlgoliaDataContext } from '../hooks/useAlgoliaDataContext';
import { queryLetter } from '../configs';
import { useSEOKeywords } from '../hooks/useSEOKeywords';
import { useDynamicConfigs } from '../hooks/useDynamicConfigs';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../constants/searchParamKeys';
const headTitles = document.querySelectorAll('head title');
const metaTitles = document.querySelectorAll('head meta[property="og:title"], head meta[name="twitter:title"]');
const metaDescriptions = document.querySelectorAll('head meta[name="description"], head meta[property="og:description"], head meta[name="twitter:description"]');
export const SEOMetaData = () => {
    const { collection } = useDynamicConfigs();
    const { kw1, kw2, layoutKey, mediumKey } = useSEOKeywords();
    const { nbHits } = useAlgoliaDataContext();
    const [searchParams] = useSearchParams();
    const page = +(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    let title = collection?.title ?? searchParams.get(queryLetter) ?? 'Search';
    title = title[0].toUpperCase() + title.slice(1);
    const titleKw2 = mediumKey === 'noMedium' && layoutKey === 'noLayout'
        ? 'Paintings, Drawings & Photograph Art Prints'
        : layoutKey === 'noLayout'
            ? 'Prints, Framed Prints And Multi Panel Art'
            : kw2;
    const metaTitleContent = `${title} ${kw1} | ${titleKw2}${page > 1 ? ` - Page ${page}` : ''}`;
    headTitles.forEach(t => {
        t.textContent = metaTitleContent;
    });
    metaTitles.forEach(t => {
        t.setAttribute('content', metaTitleContent);
    });
    const metaDescription = layoutKey === 'noLayout'
        ? `Select from ${nbHits} curated ${title} ${kw1}, including ${title} prints, framed prints and multi panel art. Now on a special 60% discount & free returns`
        : `Select from ${nbHits} curated ${title} ${kw1}. Enjoy free returns and a special 60% discount on all our ${title} ${kw2}`;
    metaDescriptions.forEach(d => {
        d.setAttribute('content', metaDescription);
    });
    return null;
};
